import {Injectable} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {Permission, Datazone, Types, IDs, Permissions} from '../../models/principal/permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  permissionList;

  constructor(private authService: AuthService) {
    this.authService.getPermissionList.subscribe(permission => this.permissionList = permission);
  }

  resolveUserPermissions(requiredPermissions: Permission[]): { [key: string]: boolean } {
    return requiredPermissions.reduce((acc, permission) => {
      acc[permission] = this.authService.hasPermission(permission);
      return acc;
    }, {});
  }

  resolveAPIPermissions(requiredPermissions: any[]): { [key: string]: boolean } {
    return requiredPermissions.reduce((acc, permission) => {
      acc[permission.key] = this.authService.hasAPIPermission(permission);
      return acc;
    }, {});
  }

  permission() {
    return this.permissionList.find(item=> item.attribute == '');
  }

  permissionByDatazone(resource, val) {
   return this.permissionList.find(item=> item.action == resource && item.attribute == Datazone && item.attributeValue == val);
  }

  permissionByType(resource, val) {
    return this.permissionList.find(item=> item.action == resource && item.attribute == Types && item.attributeValue == val);
  }

  permissionByID(resource, val) {
    return this.permissionList.find(item=> item.action == resource && item.attribute == IDs && item.attributeValue == val);
  } 
  
}
